function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "adf7ac93-4989-4cdd-bde6-06fdb252ba8f",
  x1: 643.16981,
  y1: 665.83172,
  x2: 643.16981,
  y2: 614.27062,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.53514,
  stopColor: "gray",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "mobile user");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M189.73412,316v36a57,57,0,0,1,0,114v36h186V316Z",
  transform: "translate(-5.73412 -91)",
  fill: "#f2f2f2"
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 184,
  cy: 318,
  r: 45,
  fill: "#f2f2f2"
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "866 363.051 793 318.055 793 666 866 666 866 363.051",
  fill: "#f2f2f2"
});

var _ref7 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "681 666 754 666 754 294.016 681 249.02 681 666",
  fill: "#f2f2f2"
});

var _ref8 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "642 224.98 277 0 277 203 394 203 394 437 277 437 277 666 642 666 642 224.98",
  fill: "#f2f2f2"
});

var _ref9 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "905 387.09 905 666 943 666 1046 474 905 387.09",
  fill: "#f2f2f2"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1052.54805,623.89148C991.96825,669.17479,974.887,748.73159,974.887,748.73159s81.138,6.13807,141.71783-39.14524,77.661-124.84011,77.661-124.84011S1113.12785,578.60817,1052.54805,623.89148Z",
  transform: "translate(-5.73412 -91)",
  fill: "#3f3d56"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M974.934,747.96417s-.88919-.49652-2.49849-1.48472c-1.2834-.789-3.045-1.88995-5.17344-3.2961-19.03717-12.54364-68.35148-49.43818-88.57865-106.36407-25.3068-71.27392,4.57585-146.95816,4.57585-146.95816s65.18609,36.64574,92.87645,102.469c1.20654,2.83457,2.3233,5.72744,3.37413,8.67592,22.02085,62.01505,2.25689,127.36771-3.24665,143.29761C975.43505,746.68928,974.934,747.96417,974.934,747.96417Z",
  transform: "translate(-5.73412 -91)",
  fill: "#449e2e"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M975.22852,750.21387l-.92774-.67285c-.66308-.47852-66.41113-48.78223-83.30469-121.99805-16.89453-73.21582,21.041-145.44336,21.42676-146.16406l.54-1.01172.92774.67285c.66308.47851,66.41113,48.78223,83.30468,121.99805h0c16.89453,73.21582-21.041,145.44336-21.42676,146.16406ZM913.6543,483.36328c-4.55957,9.09668-36.332,76.02832-20.709,143.73047,15.6211,67.70215,73.50782,113.94434,81.5918,120.124,4.55957-9.09668,36.332-76.02832,20.709-143.73047h0C979.625,535.78516,921.73828,489.543,913.6543,483.36328Z",
  transform: "translate(-5.73412 -91)",
  fill: "#3f3d56"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M976.2632,744.30362c-1.47731.8604-2.76778,1.58414-3.82769,2.17583-2.3356,1.2753-3.63056,1.91769-3.63056,1.91769s-.61272-1.84238-1.54288-5.21379c-5.12874-18.44506-19.81253-82.7294,4.76236-141.774q1.93845-4.63954,4.11129-9.07927c1.20654,2.83457,2.3233,5.72744,3.37413,8.67592C1001.5307,663.02106,981.76674,728.37372,976.2632,744.30362Z",
  transform: "translate(-5.73412 -91)",
  opacity: 0.1
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1077.83554,645.08132C1048.78353,714.91306,975.841,750.97469,975.841,750.97469s-25.83991-77.158,3.2121-146.98971,101.99454-105.89336,101.99454-105.89336S1106.88755,575.24959,1077.83554,645.08132Z",
  transform: "translate(-5.73412 -91)",
  fill: "#449e2e"
});

var _ref15 =
/*#__PURE__*/
React.createElement("rect", {
  x: 894.17013,
  y: 624.06329,
  width: 268.70076,
  height: 1.9994,
  transform: "translate(48.51834 1240.71705) rotate(-67.24236)",
  fill: "#3f3d56"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1183.23412,771.49145c0,9.36489-53.869,17.93035-142.93152,24.50541-16.19314,1.191-33.55158,2.31673-51.95385,3.37725q-23.86416,1.37048-50.00826,2.57773-25.33862,1.15029-52.61261,2.13738c-57.43605,2.08829-120.92171,3.58926-188.36955,4.33979q-24.54818.26916-49.76513.42421-26.2505.14684-53.10908.14678c-325.16024,0-588.75-16.78827-588.75-37.50855s263.58976-37.50855,588.75-37.50855c139.98268,0,268.545,3.11615,369.585,8.30446q5.5785.29367,11.04542.571a.11385.11385,0,0,0,.07094.01633C1102.46091,749.75964,1183.23412,760.02194,1183.23412,771.49145Z",
  transform: "translate(-5.73412 -91)",
  fill: "#3f3d56"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1183.23412,771.49145c0,9.36489-53.869,17.93035-142.93152,24.50541-16.19314,1.191-33.55158,2.31673-51.95385,3.37725q-23.86416,1.37048-50.00826,2.57773-25.33862,1.15029-52.61261,2.13738c-57.43605,2.08829-120.92171,3.58926-188.36955,4.33979q-24.54818.26916-49.76513.42421-26.2505.14684-53.10908.14678c-325.16024,0-588.75-16.78827-588.75-37.50855s263.58976-37.50855,588.75-37.50855c139.98268,0,268.545,3.11615,369.585,8.30446q5.5785.29367,11.04542.571a.11385.11385,0,0,0,.07094.01633C1102.46091,749.75964,1183.23412,760.02194,1183.23412,771.49145Z",
  transform: "translate(-5.73412 -91)",
  opacity: 0.15
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1137.98412,764.89c0,7.83-50.22,14.99-133.25,20.49-15.09.99-31.28,1.93-48.43,2.82q-22.245,1.13992-46.62,2.15-23.625.975-49.05,1.79c-53.55,1.75-112.74,3-175.62,3.63q-22.875.225-46.39.35-24.48.13494-49.51.13c-303.14,0-548.88-14.04-548.88-31.36s245.74-31.36,548.88-31.36c67.03,0,131.25.69,190.63,1.95h.15c56.16,1.19,107.99005,2.89,153.77,5q5.205.24,10.3.47a.0954.0954,0,0,0,.07.02c20.97,1.02,40.59,2.12,58.67,3.3.2.01.4.03.6.04C1087.19409,749.82,1137.98412,757.01,1137.98412,764.89Z",
  transform: "translate(-5.73412 -91)",
  fill: "#3f3d56"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1002.7041,744.27c-7.43,48.31-54.28,32.12-110.97,32.12-59.89,0-108.79,18.07-111.84-40.91,56.16,1.19,107.99005,2.89,153.77,5q5.205.24,10.3.47a.0954.0954,0,0,0,.07.02C965.00414,741.99,984.62414,743.09,1002.7041,744.27Z",
  transform: "translate(-5.73412 -91)",
  opacity: 0.1
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M323.01087,729.57325c0,17.41683-10.35262,23.49772-23.12525,23.49772-.29585,0-.59169-.00427-.88541-.01066-.59171-.01277-1.17915-.04042-1.75808-.08086-11.52749-.81519-20.48174-7.209-20.48174-23.4062,0-16.75915,21.41612-37.90922,23.02945-39.47786l.00213-.00213c.06173-.06172.09365-.09152.09365-.09152S323.01087,712.15855,323.01087,729.57325Z",
  transform: "translate(-5.73412 -91)",
  fill: "#449e2e"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M299.04278,750.40618l8.45832-11.817-8.47961,13.1153-.02128,1.3558c-.59171-.01277-1.17915-.04042-1.75808-.08086l.911-17.42323-.00638-.13621.0149-.02342.08726-1.64739L289.748,720.602l8.52642,11.91275.02129.34906.68748-13.16426-7.27706-13.58567,7.36645,11.27635.71727-27.29481.00213-.09365v.09152l-.11919,21.52254,7.24514-8.53282L299.643,713.46966l-.19155,11.78717,6.76623-11.31254-6.7939,13.04719-.10642,6.5534,9.81838-15.746L299.279,735.8308Z",
  transform: "translate(-5.73412 -91)",
  fill: "#3f3d56"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M779.73412,717.39338c0-66.27417,50.14411-120,112-120s112,53.72583,112,120-50.1441,47-112,47S779.73412,783.66755,779.73412,717.39338Z",
  transform: "translate(-5.73412 -91)",
  fill: "#3f3d56"
});

var _ref23 =
/*#__PURE__*/
React.createElement("rect", {
  x: 151.38355,
  y: 547.33105,
  width: 2,
  height: 135.18066,
  fill: "#3f3d56"
});

var _ref24 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 152.38363,
  cy: 547.33141,
  r: 19.11639,
  fill: "#3f3d56"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M158.11776,721.64576s-2.73092-58.73613-58.71464-51.90885",
  transform: "translate(-5.73412 -91)",
  fill: "#3f3d56"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M714.7479,660.57405c.499,1.76447,1.05571,3.51728,1.651,5.25767-2.67-2.6244-5.28956-5.32006-7.95953-7.92844,1.071.33378,2.13887.66706,3.14849,1.06266A19.10142,19.10142,0,0,1,714.7479,660.57405Zm-12.93212-8.76483c-15.7352-13.68178-33.96742-24.27416-50.09265-37.5386,8.80552,4.33207,17.37067,9.37993,25.86743,14.22052q15.11745,8.6124,30.59415,16.55509A24.94985,24.94985,0,0,1,701.81578,651.80922Zm6.73063-34.4515q.376-.384.75333-.77258c.00723,1.94381.02194,3.76123.04523,5.4113q-2.11473-.70159-4.21768-1.43895A37.23886,37.23886,0,0,0,708.54641,617.35772ZM569.94068,654.398a129.41265,129.41265,0,0,0,16.79078-23.95217c6.24672,10.91349,16.39758,18.78283,25.03211,27.923C597.85186,656.53279,583.91858,655.0173,569.94068,654.398Z",
  transform: "translate(-5.73412 -91)",
  fill: "url(#adf7ac93-4989-4cdd-bde6-06fdb252ba8f)"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M123.01087,755.57325c0,17.41683-10.35262,23.49772-23.12525,23.49772-.29585,0-.59169-.00427-.88541-.01066-.59171-.01277-1.17915-.04042-1.75808-.08086-11.52749-.81519-20.48174-7.209-20.48174-23.4062,0-16.75915,21.41612-37.90922,23.02945-39.47786l.00213-.00213c.06173-.06172.09365-.09152.09365-.09152S123.01087,738.15855,123.01087,755.57325Z",
  transform: "translate(-5.73412 -91)",
  fill: "#449e2e"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.04278,776.40618l8.45832-11.817-8.47961,13.1153-.02128,1.3558c-.59171-.01277-1.17915-.04042-1.75808-.08086l.911-17.42323-.00638-.13621.0149-.02342.08726-1.64739L89.748,746.602l8.52642,11.91275.02129.34906.68748-13.16426-7.27706-13.58567,7.36645,11.27635.71727-27.29481.00213-.09365v.09152l-.11919,21.52254,7.24514-8.53282L99.643,739.46966l-.19155,11.78717,6.76623-11.31254-6.7939,13.04719-.10642,6.5534,9.81838-15.746L99.279,761.8308Z",
  transform: "translate(-5.73412 -91)",
  fill: "#3f3d56"
});

var _ref29 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 129,
  cy: 516,
  r: 10,
  fill: "#449e2e"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M777.72234,467.03148S814,459,818,491s-19.26588,38.04025-19.26588,38.04025L784,533l-57-15,8-23Z",
  transform: "translate(-5.73412 -91)",
  fill: "#2f2e41"
});

var _ref31 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 758.91534,
  cy: 328.77374,
  r: 49.02335,
  fill: "#2f2e41"
});

var _ref32 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "586.65 430.572 596.611 432.575 630.477 482.652 615.536 484.655 586.65 430.572",
  fill: "#2f2e41"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M351.45609,724.74808a195.67048,195.67048,0,0,0,9.89887,25.84773,241.23674,241.23674,0,0,0,33.047-9.41617c.33227-.12086-6.1811-8.63987-6.865-9.33582-2.58049-2.62579-5.92091-5.69387-9.33249-7.17825-3.43989-1.49669-7.67708-.35439-11.3594-.16634Q359.158,724.89181,351.45609,724.74808Z",
  transform: "translate(-5.73412 -91)",
  fill: "#fbbebe"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M378.263,738.12555c-5.6143-1.75673-9.02614-7.40609-11.30973-12.85425s-4.12519-11.3889-8.45657-15.38723c-1.65953.07936-2.99637,1.428-3.81745,2.88027s-1.31,3.08955-2.25892,4.46079c-1.80649,2.61033-4.98161,3.87173-7.25267,6.085-2.38093,2.32034-3.68245,5.60336-6.147,7.83365-3.09567,2.8014-7.47168,3.497-11.5332,4.4236a73.96442,73.96442,0,0,0-18.04841,6.69149,30.3092,30.3092,0,0,1-6.68586,2.99631,25.11054,25.11054,0,0,1-7.81924.2611l-17.95728-1.27966a14.0313,14.0313,0,0,0-4.79343.20972c-3.69148,1.03646-5.98349,5.15642-5.71229,9.00058s2.66268,7.289,5.68278,9.66174a37.82411,37.82411,0,0,0,10.22659,5.1816,303.054,303.054,0,0,0,48.14813,13.75357l.00883,3.55417a83.15631,83.15631,0,0,0,36.652,8.534,5.70157,5.70157,0,0,0,2.74337-.47547c1.26034-.68408,1.84383-2.15613,2.30994-3.51787a142.47714,142.47714,0,0,0,7.48986-39.03785,29.63421,29.63421,0,0,0-.77313-10.05554c-.978-3.233,2.38961-1.8744-.72661-3.13982",
  transform: "translate(-5.73412 -91)",
  fill: "#2f2e41"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M722.66775,670.43048c-53.23985,3.18768-105.86052-12.39593-159.16893-14.06163-6.62747-.20709-13.32708-.19175-19.79828,1.26167-6.84556,1.53751-13.22717,4.63506-19.593,7.59683-28.591,13.30234-58.16882,24.32061-87.7106,35.32391L402.46155,713.191c-6.78149,2.52587-13.80847,5.0908-21.02694,4.64965-3.23568-.19775-7.20781-.68738-9.02826,2.00962-5.52072,8.179-2.91191,20.19547.73575,29.37472,1.184,2.97949,3.18662,6.19409,6.3597,6.53305,2.23384.23863,4.311-1.05448,6.48169-1.63583,6.17712-1.65431,12.33544,2.50067,18.69241,3.17706,7.85383.83567,15.14667-3.63809,22.55944-6.37785,12.29437-4.544,25.73732-4.40123,38.65989-6.55333,21.66859-3.60864,41.752-13.67,60.52541-25.13316,7.14893-4.36519,14.38221-9.04122,22.594-10.6377,9.44245-1.83575,19.14105.59662,28.39884,3.216a655.88535,655.88535,0,0,1,65.107,22.17033c11.21473,4.48793,22.34923,9.30061,34.018,12.405a122.99664,122.99664,0,0,0,76.23917-4.44513c8.52171-3.36793,17.78127-9.32164,18.26945-18.51535.27834-5.242-3.78673-9.86049-6.50355-14.34319-1.74224-2.87466-3.48559-5.751-5.38281-8.52475C749.98026,687.13858,738.8394,669.46222,722.66775,670.43048Z",
  transform: "translate(-5.73412 -91)",
  fill: "#2f2e41"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M722.66775,670.43048c-53.23985,3.18768-105.86052-12.39593-159.16893-14.06163-6.62747-.20709-13.32708-.19175-19.79828,1.26167-6.84556,1.53751-13.22717,4.63506-19.593,7.59683-28.591,13.30234-58.16882,24.32061-87.7106,35.32391L402.46155,713.191c-6.78149,2.52587-13.80847,5.0908-21.02694,4.64965-3.23568-.19775-7.20781-.68738-9.02826,2.00962-5.52072,8.179-2.91191,20.19547.73575,29.37472,1.184,2.97949,3.18662,6.19409,6.3597,6.53305,2.23384.23863,4.311-1.05448,6.48169-1.63583,6.17712-1.65431,12.33544,2.50067,18.69241,3.17706,7.85383.83567,15.14667-3.63809,22.55944-6.37785,12.29437-4.544,25.73732-4.40123,38.65989-6.55333,21.66859-3.60864,41.752-13.67,60.52541-25.13316,7.14893-4.36519,14.38221-9.04122,22.594-10.6377,9.44245-1.83575,19.14105.59662,28.39884,3.216a655.88535,655.88535,0,0,1,65.107,22.17033c11.21473,4.48793,22.34923,9.30061,34.018,12.405a122.99664,122.99664,0,0,0,76.23917-4.44513c8.52171-3.36793,17.78127-9.32164,18.26945-18.51535.27834-5.242-3.78673-9.86049-6.50355-14.34319-1.74224-2.87466-3.48559-5.751-5.38281-8.52475C749.98026,687.13858,738.8394,669.46222,722.66775,670.43048Z",
  transform: "translate(-5.73412 -91)",
  opacity: 0.1
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M453.67323,727.3401q12.50091,4.26635,25.22031,7.84468c4.74685-7.7935,13.62672-13.21674,15.65061-22.12622a1.94511,1.94511,0,0,0,.00143-1.19312,2.00931,2.00931,0,0,0-.95454-.85406,46.95963,46.95963,0,0,0-19.74829-5.78686c-5.47236-.34588-7.96968,5.36788-10.45072,9.38371C462.38764,716.23394,455.90312,728.10113,453.67323,727.3401Z",
  transform: "translate(-5.73412 -91)",
  fill: "#fbbebe"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M465.35451,721.65112c-4.92166-1.0316-9.73811-3.6769-12.25079-8.0554-1.1772-2.05136-2.42941-4.8166-4.77976-4.66174-2.1817.14375-3.18411,2.74664-3.67529,4.88888-1.83939,8.02225-3.646,16.10845-6.87319,23.67466s-8.00155,14.6697-14.735,19.3534c-3.088,2.148-6.53123,3.75252-9.54979,5.9981-2.71235,2.01778-5.077,4.54833-8.07277,6.109a45.53523,45.53523,0,0,1-6.191,2.30912,41.93448,41.93448,0,0,0-8.86639,4.315,17.83735,17.83735,0,0,0-6.03736,5.76848,8.45983,8.45983,0,0,0-.49746,8.07324,8.73738,8.73738,0,0,0,5.90951,4.04714,25.30029,25.30029,0,0,0,7.34506.18411c9.70713-.7154,19.40273-1.57967,29.09788-2.4439a83.43759,83.43759,0,0,0,12.19611-1.696c2.12391-.51235,4.20473-1.19081,6.32044-1.73638a52.12627,52.12627,0,0,1,11.08575-1.61447,9.28882,9.28882,0,0,1,3.23418.2954c2.24608.73378,3.83995,2.96842,6.15814,3.4219a9.77613,9.77613,0,0,0,4.38525-.58605c6.98526-1.91021,14.32521-1.85866,21.55378-2.24884,3.185-.17193,6.913-.777,8.37423-3.6279,1.82221-3.55518-1.1994-7.53058-2.40342-11.34251a34.72289,34.72289,0,0,1-.9988-7.43817,45.54779,45.54779,0,0,0-5.3465-17.68453c-2.471-4.53743-5.84471-9.55418-4.10828-14.42381.5892-1.65236,1.76091-3.19084,1.64446-4.94248C487.76168,719.895,469.81727,722.58653,465.35451,721.65112Z",
  transform: "translate(-5.73412 -91)",
  fill: "#2f2e41"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M642.82845,585.01706a41.66573,41.66573,0,0,1-21.21356-21.07084c-.88912-2.02146-1.61973-4.1323-2.47591-6.173a46.89839,46.89839,0,0,0-12.6782-17.60634c-1.38625-1.17588-3.01261-2.29824-4.70628-1.99056-1.62518.29524-2.904,1.90321-3.4616,3.70682a15.12244,15.12244,0,0,0-.3513,5.68868,101.86261,101.86261,0,0,0,2.307,13.30683l2.58,11.75624a22.52364,22.52364,0,0,0,1.606,5.2478,18.47989,18.47989,0,0,0,4.331,5.18134q3.53526,3.25644,7.18533,6.33855a20.078,20.078,0,0,0,12.45951,5.54006c10.57269,1.96068,21.32586,4.78483,30.24752,11.68451-.099-.07654-.03787-7.88531-.19229-8.7804-.40814-2.36576-.72619-4.70872-2.26594-6.30823C652.74081,587.94537,647.04153,586.8897,642.82845,585.01706Z",
  transform: "translate(-5.73412 -91)",
  fill: "#fbbebe"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M642.82845,585.01706a41.66573,41.66573,0,0,1-21.21356-21.07084c-.88912-2.02146-1.61973-4.1323-2.47591-6.173a46.89839,46.89839,0,0,0-12.6782-17.60634c-1.38625-1.17588-3.01261-2.29824-4.70628-1.99056-1.62518.29524-2.904,1.90321-3.4616,3.70682a15.12244,15.12244,0,0,0-.3513,5.68868,101.86261,101.86261,0,0,0,2.307,13.30683l2.58,11.75624a22.52364,22.52364,0,0,0,1.606,5.2478,18.47989,18.47989,0,0,0,4.331,5.18134q3.53526,3.25644,7.18533,6.33855a20.078,20.078,0,0,0,12.45951,5.54006c10.57269,1.96068,21.32586,4.78483,30.24752,11.68451-.099-.07654-.03787-7.88531-.19229-8.7804-.40814-2.36576-.72619-4.70872-2.26594-6.30823C652.74081,587.94537,647.04153,586.8897,642.82845,585.01706Z",
  transform: "translate(-5.73412 -91)",
  opacity: 0.1
});

var _ref41 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 745.52085,
  cy: 391.01085,
  rx: 12.9487,
  ry: 13.02008,
  fill: "#2f2e41"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M743.23959,474.14469c-3.515-.38983-7.41916-.67905-10.23554,1.47134a13.97808,13.97808,0,0,0-3.50234,4.76882c-2.70725,5.08309-5.37676,10.26247-6.73934,15.86345-1.15606,4.75207-1.34784,9.72124-2.77927,14.3969-2.65535,8.67346-9.45814,15.99427-10.23562,25.03565-.34792,4.0459.32938,8.78288-2.62228,11.55472a17.34929,17.34929,0,0,1-2.32675,1.65026,17.60478,17.60478,0,0,0-5.09674,5.24089c-1.10508,1.75568-1.956,3.77253-3.61936,5.00532-2.63322,1.9516-7.00494,1.753-8.30307,4.77212-1.3339,3.10237,2.05109,6.55546,1.26693,9.84209-.63871,2.677-3.62281,3.90368-5.678,5.72264-2.63292,2.33036-3.83672,5.84608-4.93451,9.19586a30.534,30.534,0,0,1-24.77846-6.17913c3.615,8.90286,3.69271,18.72812,3.84979,28.34315.051,3.11919-.04628,6.6197-2.2731,8.7919,10.30881.22075,20.3631,3.01355,30.42326,5.28716,4.39679.99368,9.17,1.85656,13.26994-.02421a21.651,21.651,0,0,0,6.07728-4.83373c5.47262-5.54981,11.214-11.60423,12.55294-19.30282.75023-4.31354.02365-8.74059.22223-13.115.246-5.42009,1.90337-10.6579,3.32221-15.89271a187.52863,187.52863,0,0,0,5.81538-32.72556c.59578-6.82446,6.49023-12.31707,9.59314-18.41606,5.8578-11.51392,11.84409-23.50568,12.28545-36.4311C748.94141,479.8442,747.5149,474.61884,743.23959,474.14469Z",
  transform: "translate(-5.73412 -91)",
  fill: "#2f2e41"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M743.23959,474.14469c-3.515-.38983-7.41916-.67905-10.23554,1.47134a13.97808,13.97808,0,0,0-3.50234,4.76882c-2.70725,5.08309-5.37676,10.26247-6.73934,15.86345-1.15606,4.75207-1.34784,9.72124-2.77927,14.3969-2.65535,8.67346-9.45814,15.99427-10.23562,25.03565-.34792,4.0459.32938,8.78288-2.62228,11.55472a17.34929,17.34929,0,0,1-2.32675,1.65026,17.60478,17.60478,0,0,0-5.09674,5.24089c-1.10508,1.75568-1.956,3.77253-3.61936,5.00532-2.63322,1.9516-7.00494,1.753-8.30307,4.77212-1.3339,3.10237,2.05109,6.55546,1.26693,9.84209-.63871,2.677-3.62281,3.90368-5.678,5.72264-2.63292,2.33036-3.83672,5.84608-4.93451,9.19586a30.534,30.534,0,0,1-24.77846-6.17913c3.615,8.90286,3.69271,18.72812,3.84979,28.34315.051,3.11919-.04628,6.6197-2.2731,8.7919,10.30881.22075,20.3631,3.01355,30.42326,5.28716,4.39679.99368,9.17,1.85656,13.26994-.02421a21.651,21.651,0,0,0,6.07728-4.83373c5.47262-5.54981,11.214-11.60423,12.55294-19.30282.75023-4.31354.02365-8.74059.22223-13.115.246-5.42009,1.90337-10.6579,3.32221-15.89271a187.52863,187.52863,0,0,0,5.81538-32.72556c.59578-6.82446,6.49023-12.31707,9.59314-18.41606,5.8578-11.51392,11.84409-23.50568,12.28545-36.4311C748.94141,479.8442,747.5149,474.61884,743.23959,474.14469Z",
  transform: "translate(-5.73412 -91)",
  opacity: 0.1
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M731.11207,681.643c-11.0884-5.27543-19.20154-15.11268-28.16707-23.53127-17.11553-16.0714-38.04606-27.44864-56.04168-42.51671-11.92866-9.98809-22.5969-21.61842-35.70482-29.97969a88.87689,88.87689,0,0,0-38.23972-13.39909,10.76961,10.76961,0,0,0-4.68263.234,11.08752,11.08752,0,0,0-4.35289,3.44289,136.166,136.166,0,0,0-15.41292,21.19457c-22.8098,38.72114-55.209,71.27859-82.05217,107.29028a4.8146,4.8146,0,0,0-.32061,6.50086l5.46037,10.69993c3.05541,5.98724,7.95055,12.96156,14.53769,11.77173,3.01007-.54371,5.40871-2.75848,7.6252-4.87724l24.51283-23.432,25.70012-24.567c15.05816-14.39423,30.37392-29.12291,40.19013-47.53556,7.672,13.3059,21.28307,22.01449,30.62211,34.19541,3.55219,4.63313,6.4537,9.72812,9.6248,14.63286,5.08334,7.86239,10.86371,15.24148,16.6351,22.608l29.48017,37.62827c4.02036,5.13156,8.15228,10.36572,13.65,13.84646,6.98209,4.4205,15.47365,5.58519,23.692,6.32116A313.60552,313.60552,0,0,0,741.179,763.375c8.47576-.14452,17.21723-.70084,24.82276-4.46516s13.85345-11.49156,13.45806-20.006c-.20562-4.42783-2.13048-8.58068-4.24919-12.46783C764.67979,707.11536,750.91824,691.066,731.11207,681.643Z",
  transform: "translate(-5.73412 -91)",
  fill: "#2f2e41"
});

var _ref45 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 753.48928,
  cy: 400.02475,
  rx: 9.96054,
  ry: 10.01544,
  fill: "#2f2e41"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M757.02135,483.49936c2.42767,4.28763,2.42943,9.62418,1.09337,14.37156s-3.88729,9.04166-6.41094,13.27288c-2.48378,4.16439-4.996,8.36668-8.32793,11.88162,15.3741.73583,30.27889-5.29483,43.84673-12.60207,10.91522-5.87861,21.80738-13.13559,27.63287-24.1222-3.40691,1.02351-7.16154.01338-10.177-1.88112a37.87028,37.87028,0,0,1-7.798-7.26291l-7.71872-8.683a34.65,34.65,0,0,1-4.74715-6.2312,17.51648,17.51648,0,0,1-2.03777-10.07227,57.57635,57.57635,0,0,1-10.2136,8.47552c-5.513,3.588-11.59017,6.19084-17.11473,9.7577-1.95957,1.26516-6.31541,3.29962-5.19415,5.8599C750.94777,478.76057,755.46793,480.75581,757.02135,483.49936Z",
  transform: "translate(-5.73412 -91)",
  fill: "#fbbebe"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M757.02135,483.49936c2.42767,4.28763,2.42943,9.62418,1.09337,14.37156s-3.88729,9.04166-6.41094,13.27288c-2.48378,4.16439-4.996,8.36668-8.32793,11.88162,15.3741.73583,30.27889-5.29483,43.84673-12.60207,10.91522-5.87861,21.80738-13.13559,27.63287-24.1222-3.40691,1.02351-7.16154.01338-10.177-1.88112a37.87028,37.87028,0,0,1-7.798-7.26291l-7.71872-8.683a34.65,34.65,0,0,1-4.74715-6.2312,17.51648,17.51648,0,0,1-2.03777-10.07227,57.57635,57.57635,0,0,1-10.2136,8.47552c-5.513,3.588-11.59017,6.19084-17.11473,9.7577-1.95957,1.26516-6.31541,3.29962-5.19415,5.8599C750.94777,478.76057,755.46793,480.75581,757.02135,483.49936Z",
  transform: "translate(-5.73412 -91)",
  opacity: 0.1
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M757.2313,485.01549c-2.88941,4.85892-3.509,10.59587,0,15.02316.43662.55087,2.05928,3.97043,2.75913,4.00209a2.613,2.613,0,0,0,1.75471-.88766c3.73358-3.41331,6.46917-7.76644,9.74942-11.622s7.41785-7.36945,12.40447-8.14608c6.01873-.93737,11.83013,2.25192,17.09623,5.32859,2.18872,1.27873,4.4584,2.63324,5.83659,4.76824a15.61115,15.61115,0,0,1,1.91655,6.51454c1.81913,13.706,1.779,27.58429,1.73577,41.4117-.03126,9.99517-.069,20.06077-1.95949,29.87356-.97712,5.0719-2.44507,10.05008-3.13909,15.16891a101.82165,101.82165,0,0,0-.61864,13.61008L804.7523,619.09a48.99984,48.99984,0,0,0,.738,10.43489c.9039,4.16991,2.87668,8.01931,4.19577,12.07578a79.66891,79.66891,0,0,1,2.77992,14.27219l2.60444,19.70516c.82021,6.20568,1.42625,12.99455-2.32618,17.99-1.69657,2.25856-3.92578,4.0665-5.64609,6.30683-6.44174,8.389-4.37466,20.35864-7.06245,30.60683a38.35837,38.35837,0,0,1-12.49312,19.15117c-4.60313,3.91093-10.5488,6.98829-16.475,5.888-8.00117-1.48559-12.807-9.82816-14.98816-17.71s-2.97651-16.46138-7.703-23.12069c-3.859-5.43707-9.83839-8.8571-15.24482-12.73856s-10.68925-8.885-11.86623-15.45908c-.51406-2.87133-.19411-5.82857-.499-8.72991a20.6556,20.6556,0,0,0-12.74678-16.73815c-4.09563-1.59288-9.154-2.16179-11.46009-5.91944,5.9551-3.35573,9.9081-9.55764,11.99062-16.09456s2.5071-13.473,2.91651-20.32472l1.36822-22.89793c.61146-10.23309.88863-20.375,5.39525-29.57067,2.01462-4.11077,4.5214-7.959,6.61841-12.02793a135.29557,135.29557,0,0,0,7.08923-17.64781c3.26693-9.38242,6.53474-18.76754,9.44685-28.26735,1.38762-4.52669,2.721-9.13988,5.19432-13.17136S752.60065,485.88593,757.2313,485.01549Z",
  transform: "translate(-5.73412 -91)",
  fill: "#449e2e"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M706.38375,633.77686l6.05675.21853,1.29053-9.15692a19.195,19.195,0,0,1,1.283-5.33865,32.975,32.975,0,0,1,3.48314-5.10429c5.96393-8.42482,5.52929-19.6113,7.00656-29.8452,1.97029-13.64947,7.672-26.42819,13.31244-39.00066l11.76148-26.21637a28.41432,28.41432,0,0,0,3.25239-14.47058c.10414-4.05285,1.305-18.799,1.40913-22.85187.03854-1.49973-3.30669-.66645-3.98421-2.00309-1.47536-2.91059-3.49314,4.98281-6.248,6.71461s-4.27524,4.86882-5.44493,7.91661c-2.53455,6.60409-4.08439,13.54928-6.446,20.21786s-5.666,13.22017-10.98,17.86324c-2.4147,2.10984-5.197,3.78318-7.47776,6.03864-7.31754,7.23624-8.03025,18.66344-8.28766,28.98014C706.2176,573.872,705.03242,633.77686,706.38375,633.77686Z",
  transform: "translate(-5.73412 -91)",
  fill: "#2f2e41"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M793.61237,474.08273c-5.885,2.31389-9.112,8.6961-10.76594,14.82835s-2.32755,12.668-5.48857,18.16967c-7.38917,12.86053-26.22925,16.60836-31.44242,30.50508-1.70584,4.54724-1.63213,9.53626-2.09153,14.37424-.94556,9.95766-4.21958,19.57779-5.1874,29.53329-.74976,7.71247-.10246,15.48535.54495,23.20719l6.58456,78.53528c.95111,11.344.9267,23.52995-1.97236,34.53464,6.6667,1.30042,13.59819-.44007,19.78307-3.26s11.83-6.69112,17.78377-9.97566c10.23684-5.64739,21.52595-9.64884,30.49054-17.17161a17.72076,17.72076,0,0,0,4.10816-4.54083c1.79608-3.10513,1.94347-6.86139,2.79808-10.34923a56.74382,56.74382,0,0,1,2.9514-8.13391,242.34829,242.34829,0,0,0,8.56545-24.21413,133.82254,133.82254,0,0,0,3.93914-16.62752c.71855-4.47647,1.10667-8.999,1.49419-13.51664a80.87085,80.87085,0,0,1,4.18007-20.759,166.31523,166.31523,0,0,0,9.61637-49.74549,25.14026,25.14026,0,0,0-.49479-7.32317c-.78029-2.9811-2.53978-5.587-3.98337-8.3065-2.73612-5.15443-4.37931-10.827-6.96181-16.061-5.83573-11.82728-16.14107-20.7945-26.9366-28.31015C805.82561,475.78475,799.618,471.72142,793.61237,474.08273Z",
  transform: "translate(-5.73412 -91)",
  fill: "#2f2e41"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M655.94787,602.20235c-4.55667-2.65355-9.112-5.51109-12.54157-9.52884-1.64311-1.92491-2.99934-4.08527-4.66979-5.98624-4.06338-4.62413-9.82137-7.49152-15.77434-8.99036s-12.14366-1.72643-18.28021-1.778c-4.10517-.03451-8.31149.02412-12.15479,1.47521s-7.30921,4.5799-8.0521,8.6397c-.89384,4.88474,2.29762,9.64469,6.13,12.77826a29.529,29.529,0,0,0,12.252,5.94744,98.27892,98.27892,0,0,0,11.07525,1.29762c21.80408,2.28316,41.25538,14.15049,60.36238,24.95666q25.17113,14.23579,51.321,26.61874a102.3689,102.3689,0,0,0,.86018-15.75319c-.089-3.93229-.28263-9.92667-3.99709-12.23538-4.32782-2.68994-11.45269-3.308-16.33482-4.9082a262.17112,262.17112,0,0,1-32.84177-13.28511Q664.4567,607.15572,655.94787,602.20235Z",
  transform: "translate(-5.73412 -91)",
  fill: "#fbbebe"
});

var _ref52 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 745.52085,
  cy: 348.94599,
  rx: 38.84611,
  ry: 39.06023,
  fill: "#fbbebe"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M804.718,518.36775c-3.46962,4.04574-5.2065,9.25642-7.53775,14.05689-4.797,9.87781-12.31988,18.35587-16.08748,28.675-3.97472,10.8864-3.84152,23.83545-11.63275,32.386-1.35471,1.48674-2.98985,2.92161-3.38163,4.89917-.23254,1.17377.00883,2.43017-.39578,3.55573-1.11668,3.10637-6.20132,3.263-7.15062,6.42519-.27778.92529-.12133,1.95023-.46531,2.85275-.77946,2.04517-3.48035,2.35754-5.28605,3.58245-3.77045,2.55771-3.01015,8.50485-5.701,12.19192-2.12889,2.91706-6.14223,3.89454-9.70683,3.39985s-6.82942-2.201-10.0757-3.762a9.16875,9.16875,0,0,0-3.62378-1.1379,7.60571,7.60571,0,0,0-4.18373,1.42865c-7.17586,4.56236-10.54427,13.59941-10.49451,22.13608s2.98293,16.76169,5.987,24.74623a10.65187,10.65187,0,0,0,1.9796,3.68643c2.37916,2.51579,6.52251,2.10933,9.68213.70983s6.02967-3.60147,9.42756-4.21694c6.011-1.08879,11.8856,3.04165,17.984,2.70166,4.46771-.24908,8.42141-2.84689,12.1332-5.35955,5.9249-4.01079,11.95852-8.12261,16.31456-13.81419,2.66741-3.48523,4.62132-7.45817,6.94693-11.18273a129.18647,129.18647,0,0,1,9.81049-13.10239l22.39937-27.41823A44.3185,44.3185,0,0,0,832.38864,584.963c2.1295-7.30734,4.2735-14.69838,4.64212-22.30395.30341-6.26028-.60533-12.51147-1.62667-18.69446-1.00536-6.08627-2.14981-12.24035-4.82348-17.79346C825.7143,516.064,813.86633,507.70035,804.718,518.36775Z",
  transform: "translate(-5.73412 -91)",
  fill: "#2f2e41"
});

var _ref54 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 812.02396,
  cy: 264.22634,
  r: 49.02335,
  fill: "#2f2e41"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  d: "M860.04334,395.82082a49.026,49.026,0,0,1-75.705-25.74134,49.02605,49.02605,0,1,0,95.63134-20.10411A49.008,49.008,0,0,1,860.04334,395.82082Z",
  transform: "translate(-5.73412 -91)",
  fill: "#2f2e41"
});

var _ref56 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 771.98822,
  cy: 336.94428,
  r: 35.95046,
  fill: "#2f2e41"
});

var _ref57 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 741.75717,
  cy: 323.46284,
  rx: 31.86517,
  ry: 24.9202,
  fill: "#2f2e41"
});

var _ref58 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 755,
  cy: 453.5,
  rx: 5,
  ry: 7.5,
  transform: "translate(-122.62254 486.99033) rotate(-39.11755)",
  fill: "#fbbebe"
});

var _ref59 =
/*#__PURE__*/
React.createElement("path", {
  d: "M720.01087,771.57325c0,17.41683-10.35262,23.49772-23.12525,23.49772-.29585,0-.59169-.00427-.88541-.01066-.59171-.01277-1.17915-.04042-1.75808-.08086-11.52749-.81519-20.48174-7.209-20.48174-23.4062,0-16.75915,21.41612-37.90922,23.02945-39.47786l.00213-.00213c.06173-.06172.09365-.09152.09365-.09152S720.01087,754.15855,720.01087,771.57325Z",
  transform: "translate(-5.73412 -91)",
  fill: "#449e2e"
});

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  d: "M696.04278,792.40618l8.45832-11.817-8.47961,13.1153-.02128,1.3558c-.59171-.01277-1.17915-.04042-1.75808-.08086l.911-17.42323-.00638-.13621.0149-.02342.08726-1.64739L686.748,762.602l8.52642,11.91275.02129.34906.68748-13.16426-7.27706-13.58567,7.36645,11.27635.71727-27.29481.00213-.09365v.09152l-.11919,21.52254,7.24514-8.53282L696.643,755.46966l-.19155,11.78717,6.76623-11.31254-6.7939,13.04719-.10642,6.5534,9.81838-15.746L696.279,777.8308Z",
  transform: "translate(-5.73412 -91)",
  fill: "#3f3d56"
});

var SvgGirlOnPhone = function SvgGirlOnPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "bfbb5b39-9b4a-43f6-b630-7b09a59f4f63",
    "data-name": "Layer 1",
    width: 1188.53175,
    height: 718,
    viewBox: "0 0 1188.53175 718",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGirlOnPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/girlOnPhone.7e7b15e2.svg";
export { ForwardRef as ReactComponent };